import { render, staticRenderFns } from "./HuddleDetails.vue?vue&type=template&id=28bc613c&scoped=true"
import script from "./HuddleDetails.vue?vue&type=script&lang=js"
export * from "./HuddleDetails.vue?vue&type=script&lang=js"
import style0 from "./HuddleComponentsModern.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./HuddleDetails.vue?vue&type=style&index=1&id=28bc613c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bc613c",
  null
  
)

export default component.exports